import {css, html, LitElement, TemplateResult} from "lit";
import {customElement} from "lit/decorators.js";
import {currentRoom} from "@adventure-game/api/src/currentRoom";

@customElement("hint-component")
export class Hint extends LitElement {
    public static styles = css`
        .hint-container {
            position: fixed;
            z-index: 10001;
            background-color: rgba(0, 0, 0, 0.5);
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            display: none;
            justify-content: center;
            align-items: center;
            font-family: "Onesize", sans-serif;
        }

        .hint-content {
            position: relative;
            padding: 5px 20px;
            background-color: #313638;
            border-radius: 5px;
            min-height: 500px;
            max-width: 1024px;
            width: 65%;
        }

        .hint-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            align-content: center;
            border-bottom: 1px solid white;
            margin: 0 0 10px 0;
        }

        .hint-content button {
            padding: 5px 10px;
            border: none;
            cursor: pointer;
            font-size: 1.5em;
            background-color: red;
            color: white;
            font-family: "Onesize", sans-serif;
        }

        .hint-content p {
            color: white;
            margin: 0 0 0 0;
            font-size: 1.2em;
            padding: 5px;
        }

        h2 {
            color: white;
            font-size: 2em;
            margin: 2% 0;
        }

        legend {
            display: flex;
            flex-direction: column;
            align-content: center;
            text-align: center;
        }

        .hint-header input {
            font-size: 1.3em;
            text-align: center;
            font-family: "Onesize", sans-serif;
        }

        label {
            font-size: 17px;
            color: white;
        }

    `;

    private selectedHint: string = "";

    protected render(): TemplateResult {
        return html`
            <div class="hint-container">
                <div class="hint-content">
                    <div class="hint-header">
                        <h2>Hint:</h2>
                        <legend for="hint">
                            <input type="number" @input="${this.handleInput}" min="1" max="5" placeholder="0">
                            <label for="hint">Select a hint level:</label>
                        </legend>
                        <button @click="${this.hideModal}">Exit</button>
                    </div>
                    <p>${this.hintMessage()}</p>
                </div>
        `;
    }


    private handleInput(event: Event): void {
        const inputElement: HTMLInputElement = event.target as HTMLInputElement;
        this.selectedHint = inputElement.value;
        this.requestUpdate();
    }

    private currentRoom: string = "";

    private hintMessage(): string {
        let message: string = "Please choose a number in the input field to view various available hints.";

        if (currentRoom) {
            if (this.currentRoom !== currentRoom.currentRoom) {
                this.currentRoom = currentRoom.currentRoom;
                this.selectedHint = "";
                return message;
            }

            if (currentRoom.currentRoom === "baby-room") {
                if (this.selectedHint === "1") {
                    message = "The baby is crying, so I should try to calm him down. He really likes his teddy bear, but it's fallen out of the crib.";
                } else if (this.selectedHint === "2") {
                    message = "There's a puzzle on the floor that needs solving, but it's missing some pieces. Those missing pieces might be hidden somewhere in the room. It's worth examining the various objects in the room to find them.";
                } else if (this.selectedHint === "3") {
                    message = "After solving the puzzle, I heard the bookcase make an odd noise. I should examine the bookcase to see what happened.";
                }else if (this.selectedHint === "4") {
                    message = "The number of seconds in a day is 86400.";
                }else if (this.selectedHint === "5") {
                    message = "I should input the number 864 into the keypad of the revealed door. Examine the hidden door.";
                }
            }
            if (currentRoom.currentRoom=== "LivingRoom") {
                if (this.selectedHint === "1") {
                    message = "Talk to your daughter. that will help you for sure!";
                } else if (this.selectedHint === "2") {
                    message = "Couldn't fix it? Pick up the orange book.";
                } else if (this.selectedHint === "3") {
                    message = "Still didn't know it? you need only to pick up the paper to leave the room.";
                }

            }
            if (currentRoom.currentRoom=== "Kitchen") {
                if (this.selectedHint === "1") {
                    message = "Flip over the fruit bowl to go to the next room.";
                } else if (this.selectedHint === "2") {
                    message = "Keuken 2.";
                } else if (this.selectedHint === "3") {
                    message = "Keuken 3.";
                }
            }
            if (currentRoom.currentRoom=== "bedroom") {
                if (this.selectedHint === "1") {
                    message = "You should talk to emily first.";
                } else if (this.selectedHint === "2") {
                    message = " Search for a key.";
                } else if (this.selectedHint === "3") {
                    message = " Try to find something that might help you later on.";
                }
            }
            if (currentRoom.currentRoom=== "ClosedRoom") {
                if (this.selectedHint === "1") {
                    message = "talk to siri.";
                } else if (this.selectedHint === "2") {
                    message = " take a look at name on the screen .";
                } else if (this.selectedHint === "3") {
                    message = " Take a look at the number-letter combination";
                }
            }
        }
        return message;
    }

    private hideModal(): void {
        const hintContainer: HTMLElement = this.shadowRoot?.querySelector(".hint-container") as HTMLElement;
        hintContainer.style.display = "none";
    }

}